<div class="ss-wrapper" [class.disabled]="disabled">
	<button type="button" class="ss-trigger form-control" (click)="toggle()"
		[class.is-invalid]="invalid"
		[disabled]="disabled" [attr.aria-expanded]="open" [attr.aria-label]="ariaLabel || placeholder">
		<span class="ss-value" [class.placeholder]="!hasSelection">{{ selectedLabel }}</span>
		<span class="ss-caret" aria-hidden="true"></span>
	</button>

	@if (open) {
		<ul class="ss-menu" [class.drop-up]="dropUp" role="listbox">
			@for (option of options; track option.value; let i = $index) {
				@if (showGroupHeader(option, i)) {
					<li class="ss-group" role="presentation">{{ option.group }}</li>
				}
				<li class="ss-option" role="option"
					[class.selected]="isSelected(option)"
					[attr.aria-selected]="isSelected(option)"
					(click)="select(option)">
					{{ option.label }}
				</li>
			}
		</ul>
	}
</div>
